// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"427":"connect","773":"welcome","954":"calculator"}[chunkId] || chunkId) + "." + {"244":"272c8b9a","427":"7a748e9b","773":"358b7915","954":"b934eafb"}[chunkId] + ".css";
};